"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const RecordingsTable_1 = __importDefault(require("@Components/ViewWork/RecordingsTable"));
const ViewWorkSection_1 = __importDefault(require("@Components/ViewWork/ViewWorkSection"));
const generate_edit_link_1 = __importDefault(require("@App/helpers/generate-edit-link"));
const EditButton_1 = require("@Components/ViewWork/EditButton");
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
require("./index.scss");
const RecordingsSection = ({ work, rightsholderId, workType, editing, errors }) => {
    const PAGE_LIMIT = 10;
    const recordingLen = work.recordings.length;
    const [currentPage, setCurrentPage] = (0, react_1.useState)(1);
    const [recordingPage, setRecordingPage] = (0, react_1.useState)(work.recordings.slice(0, PAGE_LIMIT));
    const handlePage = (pagination) => {
        var _a;
        const newPage = (_a = pagination.page) !== null && _a !== void 0 ? _a : 1;
        setCurrentPage(newPage);
        setRecordingPage(work.recordings.slice((newPage - 1) * PAGE_LIMIT, newPage * PAGE_LIMIT));
    };
    const recordingsEditLink = (0, generate_edit_link_1.default)('recordings', work.id, rightsholderId, workType);
    return (react_1.default.createElement(ViewWorkSection_1.default, { valid: editing !== undefined ? !errors : undefined, icon: 'recordings', title: 'Recordings', count: recordingLen, rightData: react_1.default.createElement("div", { className: 'recordings-right-data' },
            react_1.default.createElement(CustomToolTip_1.default, { info: 'This displays recording data that will be matched to your work. Any data input in the works registration process will not be shown here but is stored in the database.', type: '?', inverse: true }),
            editing && react_1.default.createElement(EditButton_1.EditButton, { linkTo: recordingsEditLink, workType: workType, wizardFlowIndex: 4 })) },
        react_1.default.createElement(RecordingsTable_1.default, { recordings: recordingPage, handlePage: handlePage, errors: errors, totalRecordings: recordingLen, currentPage: currentPage, recordingType: 'registration', editing: editing })));
};
exports.default = RecordingsSection;
